module.exports = __webpack_public_path__ + "static/media/whiteQuestionMark.8bca6d09.svg";